export interface TimeSlot {
  id?: string;
  startTime: string;
  endTime: string;
  slotOrder: number;
}

// Utility function to create a time slot
export function createTimeSlot(startTime: string, endTime: string, slotOrder: number): TimeSlot {
  return {
    startTime,
    endTime,
    slotOrder,
  };
}

export interface DaySchedule {
  dayOfWeek: number;
  dayName: string;
  timeSlots: TimeSlot[];
  isClosed: boolean; // Day is closed if timeSlots array is empty
}

// Utility function to check if a day is closed
export function isDayClosed(day: DaySchedule): boolean {
  return day.timeSlots.length === 0;
}

export interface OpeningHoursData {
  weeklyHours: DaySchedule[];
}

export interface BusinessSettings {
  businessName: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  openingHours: OpeningHoursData;
  appointmentLimits: {
    dailyLimit: number;
    hourlyLimit: number;
    concurrentLimit: number;
    includedAppointmentStatuses: string[];
  };
  schedulingSettings: {
    timeSlotInterval: number;
    leadTimeMinutes: number;
    bufferTimeMinutes: number;
    maxAdvanceBookingDays: number;
  };
  reminderSettings: {
    enabled: boolean;
    reminderTimes: number[];
    emailTemplate: string;
    smsEnabled: boolean;
  };
  onlineBooking: {
    enabled: boolean;
    storefrontUrl: string;
    requireDeposit: boolean;
    depositAmount: number;
  };
}

export interface SettingsSection {
  id: string;
  title: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  description: string;
  category: string;
}

export interface CategoryInfo {
  title: string;
  description: string;
}
